/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popTask.vue?vue&type=template&id=f5dfd752"
import script from "./popTask.vue?vue&type=script&lang=js"
export * from "./popTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports